import React, { Component } from 'react'
import Footer from './Footer.jsx'

import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/styles.css'
import "bootstrap/dist/css/bootstrap.min.css"

// import logo from './home/images/logo.png'

class Rules extends Component {
  render() {
    return (
      <div>


        <header id="headerBlack" className="ex-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1>Member Rules</h1>
              </div>
            </div>
          </div>
        </header>

        <div className="ex-basic-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumbs">
                  <a href="/">Home</a><i className="fa fa-angle-double-right"></i><span>Member Rules</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ex-basic-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">

                <div className="text-container">
                  <h3>No one likes a list of rules...</h3>
                  <h5>A good member is considerate of their
                  membership responsibilities. Agreeing to a few rules
                  is what makes this program work, for you and others. So, to keep us
                  all on the same page, here are our 10 rules you're required to follow
                  for membership eligibility</h5>
                  <br />
                  <ul className="list-unstyled li-space-lg indent">
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">ATTEND all that I reserve​ and to reserve only what I expect to attend. I understand multiple “No Show” reports will forfeit membership.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">CANCEL IN ADVANCE an event reservation I make and cannot attend, and ​to REVIEW the reservation confirmation in My Reservations for ​show and ​cancellation details.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Be a COURTEOUS & DISCREET audience member; to arrive early, dress appropriately and to not tell other patrons at the venue I got free tickets.​ Complaints from venues will forfeit my membership.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">CONTACT only SeatStir for changes or questions regarding my reservations - NEVER the venue.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">NEVER SELL my SeatStir tickets to others. Doing so will ​forfeit my membership​ immediately.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">ACKNOWLEDGE that SeatStir does not refund membership dues.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">NEVER ​ANNOUNCE via any social media that SeatStir has seats for a specific event. Doing so ​can ​harm the venue's ticket sales and will ​forfeit my membership​. Telling others that I enjoyed a great show and that I love my SeatStir membership however, is very much appreciated.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">REVIEW the FAQ's page and Know the Rules page on the SeatStir website, so that I am ready to ENJOY my membership and have a great time!</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">ACKNOWLEDGE the minimum subscription term - All unlimited attendance subscriptions (i.e., Plus One, Friends & Family) require an initial 6 month minimum purchase commitment unless explicitly stated otherwise. Existing Plus One members wanting to upgrade to a Friends & Family plan are able to do so at any time and will restart their 6 month commitment as of the upgrade date on their Friends & Family subscription. Friends & Family subscriptions are eligible to downgrade to a Plus One plan following the completion of their Friends & Family initial six month term.</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">NOTE that all plans will automatically renew at regular pricing until the member chooses to cancel or change his/her subscription. A member may cancel a monthly subscription at any time following the initial minimum term.</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Rules